import React from 'react';
import { Modal } from 'react-bootstrap';

import BlobDocViewer from './BlobDocViewer';
import { getApplicantDocumentsIdFile } from '../api/generated/arrayscapeGamingDashboardAPI';
import type { ApplicantDocument } from '../api/generated/model';

interface Props {
  doc: ApplicantDocument | null;
  onClose: () => void;
}

// ApplicantDocPreview renders a resume/cover-letter inline in a modal — the fetch
// and loading/error/empty handling live in BlobDocViewer.
const ApplicantDocPreview: React.FC<Props> = ({ doc, onClose }) => (
  <Modal show={!!doc} onHide={onClose} size="xl" scrollable dialogClassName="attachment-viewer-modal">
    <Modal.Header closeButton>
      <Modal.Title className="fs-6">{doc?.file_name}</Modal.Title>
    </Modal.Header>
    <Modal.Body style={{ overflow: 'hidden', padding: 0, background: '#e9ecef', minHeight: '70vh' }}>
      <BlobDocViewer
        sourceKey={doc?.id}
        fetcher={() => getApplicantDocumentsIdFile(doc!.id)}
        fileName={doc?.file_name}
        contentType={doc?.content_type}
        style={{ height: '75vh' }}
      />
    </Modal.Body>
  </Modal>
);

export default ApplicantDocPreview;
